"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CadstromMemoryMutex = exports.CadstromMemoryMutexFactory = void 0;
const cadstrom_mutex_base_1 = require("./cadstrom-mutex-base");
const Sleep_1 = require("../Utils/Sleep");
const Utils_1 = require("../Utils");
class CadstromMemoryMutexFactory {
    constructor(storage = {}) {
        this.state = storage.state ?? new Map();
        this.owners = storage.owners ?? [];
    }
    createMutex(id, opts) {
        return new CadstromMemoryMutex(this.state, this.owners, id, opts);
    }
    async createAndAcquireMutex(id, opts) {
        const mutex = this.createMutex(id, opts);
        await mutex.acquire();
        return mutex;
    }
}
exports.CadstromMemoryMutexFactory = CadstromMemoryMutexFactory;
class CadstromMemoryMutex extends cadstrom_mutex_base_1.CadstromMutexBase {
    constructor(state, owners, identifier, options = {}) {
        super();
        this.state = state;
        this.owners = owners;
        this.identifier = identifier;
        this.options = options;
        this.uid = (0, Utils_1.randomAlphaStr)(36);
        owners.push(this.uid);
    }
    get isAcquired() {
        return this.uid === this.state.get(this.identifier)?.owner;
    }
    stopRefresh() {
    }
    async acquire() {
        const acquired = await this.acquireInternal();
        if (!acquired) {
            throw new Error('Failed to acquire lock within the timeout period');
        }
    }
    async acquireInternal() {
        const { lockTimeout = 1000 * 60, retryInterval = 10, acquireAttemptsLimit = this.options.acquireTimeout && this.options.acquireTimeout > 0 ?
            Number.POSITIVE_INFINITY
            : 10, acquireTimeout = 0, } = this.options;
        const acquireDeadline = acquireTimeout ? Date.now() + acquireTimeout : Date.now() + lockTimeout;
        let attempt = 0;
        while (++attempt <= acquireAttemptsLimit) {
            if (Date.now() > acquireDeadline) {
                return false;
            }
            const isLocked = await this.checkIsLocked();
            if (!isLocked) {
                this.state.set(this.identifier, {
                    timestamp: Date.now() + lockTimeout,
                    owner: this.uid,
                });
                return true;
            }
            else {
                await (0, Sleep_1.sleep)(retryInterval);
            }
        }
        return false;
    }
    async tryAcquire() {
        return await this.acquireInternal();
    }
    checkIsLocked() {
        return Promise.resolve(this.syncCheckIsLocked());
    }
    async release() {
        if (this.uid !== this.state.get(this.identifier)?.owner) {
            return;
        }
        this.state.delete(this.identifier);
    }
    syncCheckIsLocked() {
        if (this.state.get(this.identifier)?.owner === this.uid) {
            return false;
        }
        const lock = this.state.get(this.identifier);
        if (lock?.timestamp && lock.timestamp > Date.now()) {
            return true;
        }
        return false;
    }
}
exports.CadstromMemoryMutex = CadstromMemoryMutex;
//# sourceMappingURL=cadstrom-memory-mutex.factory.js.map